import React from 'react';
import { Parallax, Background } from 'react-parallax';
import Body from './RichTextComponents';
import Button from '@mui/material/Button';
import CustomModalHeroUnit from './CustomModalHeroUnit';
import '../CSS/HeroImage.css';
import '../CSS/Modal.css';

const HeroUnit: React.FC<{ element: any }> = ({ element }) => {
  const [show, setShow] = React.useState(false);
  const handleClose = (): void => setShow(false);

  const ctaCodename = element.cta?.linkedItems[0]?.system?.codename;

  const externalUrl =
    element.cta.linkedItems[0]?.elements?.link?.linkedItems[0].elements
      .external_url.value;
  const internalUrl =
    element.cta.linkedItems[0]?.elements?.link?.linkedItems[0]?.elements
      ?.internal_link?.value;
  const newWindow =
    element.cta?.linkedItems[0]?.elements.link?.linkedItems[0]?.elements
      .open_in_new_window_.value[0].name;
  const contentColor = element.content_color.value || 'black';
  const ctaColor = element.cta_color.value || '#003370';

  const handleClick = (): void => {
    if (externalUrl) {
      window.open(externalUrl, newWindow === 'Yes' ? '_blank' : '_self');
    } else if (internalUrl) {
      window.open(internalUrl, newWindow === 'Yes' ? '_blank' : '_self');
    }
  };

  return (
    <>
      <Parallax
        strength={300}
        bgImageStyle={{
          objectFit: 'cover',
          objectPosition: 'center',
          width: '100%',
          height: '100%',
        }}
      >
        {show && (
          <CustomModalHeroUnit
            show={true}
            onHide={handleClose}
            element={element}
          />
        )}
        <div className="hero-image" onClick={(): void => setShow(true)}>
          <Background className="custom-bg">
            <img
              src={
                element.digital_asset___image.linkedItems[0].elements
                  .image_asset.value[0].url
              }
              alt={
                element.digital_asset___image.linkedItems[0].elements
                  .image_asset.value[0].description
              }
            />
          </Background>
        </div>

        {element.hero_content && (
          <div className="hero-content" style={{ color: contentColor }}>
            <Body element={element.hero_content} />
          </div>
        )}
        {ctaCodename && (
          <Button
            onClick={handleClick}
            className="cta-button"
            sx={{
              backgroundColor: ctaColor,
              color: 'white',
              padding: '10px 20px',
              border: '2px solid #003370',
              borderRadius: '5px',
              cursor: 'pointer',
              fontSize: '1em',
              marginTop: '20px',
              textTransform: 'uppercase',
              transition: 'background-color 0.3s ease',
              position: 'absolute',
              bottom: '0%',
              left: '50%',
              transform: 'translateX(-50%)',
              textDecoration: 'none',
              '&:hover': {
                backgroundColor: 'white',
                color: '#003370',
                textDecoration: 'none',
              },
              '&:focus': {
                backgroundColor: 'white',
                color: '#003370',
                textDecoration: 'none',
              },
            }}
          >
            {element.cta.linkedItems[0].elements.action_label.value ||
              'Click Here'}
          </Button>
        )}
      </Parallax>
    </>
  );
};

export default HeroUnit;
